// Laut ChatGPT ist die durchschnittliche Char-Breite für eine Ziffer 7.2px
// Dieser Wert wird hier verwendet um die Breite des Texts anzunähern
const AVERAGE_CHAR_WIDTH = 7.2;

export function truncateTextIfTooWide(text: string, maxWidth: number): string {
  const estimatedWidth = text.length * AVERAGE_CHAR_WIDTH;
  if (estimatedWidth <= maxWidth) return text;
  if (maxWidth <= AVERAGE_CHAR_WIDTH) return '';

  const maxChars = Math.floor(maxWidth / AVERAGE_CHAR_WIDTH);
  return text.slice(0, Math.max(0, maxChars - 1)) + '…';
}
